import { User } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, convertToNumber, convertTwoDecimalsOnValue, deleteData, handleDateChange, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { initializeFilterData } from "../../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox, SelectInputBox, Switch } from "../../CommonComponents/InputBox";
import { Table } from "../../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const UserMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [showPassword, setShowPassword] = useState(false);

    const initialFormData = {
        userCode: 'System Generated',
        userName: '',
        password: '',
        emailID: '',
        doj: '',
        active: true,
        "userID": "",
        "userType": "",
        "userGroupID": "",
        "pAddress": "",
        "lAddress": "",
        "phone": "",
        "isSuperAdmin": false,
        "reportingHead": "",
        "reportingHead2": "",
        "reportingHead3": "",
        "discountPercent": "",
        "employee": "",
        "company": ""
    }
    const [formData, setFormData] = useState(initialFormData);
    const GetGroupName = DropDownData('GetUserGroup')
    const GetUserType = DropDownData('GetUserType')
    const GetCompany = DropDownData('GetCompany')

    const getUserMasterData = async (CurrentPage = currentPageNo) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,

            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/ShowUserMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData(initialFormData);
        filterData.SearchText = '';
        inputrefs.current['txtUserName'].focus()
        getUserMasterData();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateUserMaster`, { ...formData, IsImport: false })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/User/EditUserMaster`, { UserID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            await inputrefs.current[editData.focus].focus();
            setFormData((pre) => ({
                ...pre, ...editData,
            }))
        } else {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteUserMaster`, { UserID: id }, getUserMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }


    const handleChange1 = (i, p) => {
        getUserMasterData(p)
    };

    //----------------Handle Toggle password----------------------//
    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
        const companies = GetCompany?.data?.dropDownData;
        if (companies?.length > 0) {
            setFormData(prev => ({
                ...prev,
                company: companies[0]?.valuePart
            }));
        }
    }, [GetCompany?.data])

    useEffect(() => {
        document.title = 'User Master'
        inputrefs.current['txtUserName'].focus()
    }, [])


    useEffect(() => {
        getUserMasterData();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <User className="w-5 h-5 text-blueled" />
                        <h2 className="text-xl font-semibold text-gray-800">User Master</h2>
                    </div>
                </div>
                <div className='card-body pb-1'>
                    <div className="row">
                        <div className='col-md-12'>
                            <div className="row">
                                <InputBox
                                    id="txtUserCode"
                                    type="text"
                                    label='User Code'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtUserName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='Enter User Code'
                                    maxLength='25'
                                    name='UserCode'
                                    value={formData.userCode}
                                    onChange={(e) => setFormData({ ...formData, userCode: sanitizeInput(e.target.value) })}
                                    //divclassname="col-md-4"
                                    disabled={true}

                                />
                                <InputBox
                                    id="txtUserName"
                                    type="text"
                                    label='User Name'
                                    required={true}
                                    placeholder="Enter User Name"
                                    maxLength='50'
                                    value={formData.userName}
                                    onChange={(e) => setFormData({ ...formData, userName: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current['txtPassword'].focus() };
                                    }}
                                //divclassname="col-md-4 "
                                />

                                <InputBox
                                    //divclassname='col-md-4 '
                                    required={true}
                                    id="txtPassword"
                                    name="password"
                                    label="Password"
                                    placeholder="Enter Password"
                                    maxLength={15}
                                    inputrefs={inputrefs}
                                    value={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") inputrefs.current["txtUserGroupName"]?.focus();
                                    }}
                                    isPasswordField
                                    showPassword={showPassword.password}
                                    togglePassword={() => handleTogglePassword("password")}
                                />

                                <SelectInputBox
                                    id="txtUserGroupName"
                                    value={formData.userGroupID}
                                    label='Group Name'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, userGroupID: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtReportingHead'].focus()
                                        }
                                    }}
                                //divclassname="col-md-4 "
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetGroupName?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>
                                <SelectInputBox
                                    id="txtCompanyName"
                                    value={formData.company}
                                    label='Company'
                                    disabled
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtReportingHead'].focus()
                                        }
                                    }}
                                //divclassname="col-md-4"
                                >
                                    {GetCompany?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>

                                {/*<InputBox*/}
                                {/*    id="txtEmployee"*/}
                                {/*    type="text"*/}
                                {/*    label='Employee'*/}
                                {/*    placeholder="Enter Employee"*/}
                                {/*    maxLength='50'*/}
                                {/*    value={formData.employee}*/}
                                {/*    onChange={(e) => setFormData({ ...formData, employee: sanitizeInput(e.target.value) })}*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') { inputrefs.current['txtReportingHead'].focus() };*/}
                                {/*    }}*/}
                                {/*//divclassname="col-md-4"*/}
                                {/*/>*/}

                                <AutoCompleteBoxNew
                                    id="txtReportingHead"
                                    placeholder="Enter Reporting Head"
                                    label='Reporting Head'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtReportingHead2"].focus(); };
                                    }}
                                    autocompleteType='GetUser'
                                    value={formData.reportingHead || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, reportingHead: newInputValue })
                                        }
                                    }}

                                />


                                <AutoCompleteBoxNew
                                    id="txtReportingHead2"
                                    placeholder="Enter Reporting Head 2"
                                    label='Reporting Head 2'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtReportingHead3"].focus(); };
                                    }}
                                    autocompleteType='GetUser'
                                    value={formData.reportingHead2 || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, reportingHead2: newInputValue })
                                        }
                                    }}

                                />

                                <AutoCompleteBoxNew
                                    id="txtReportingHead3"
                                    placeholder="Enter Reporting Head 3"
                                    label='Reporting Head 3'
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtDOJ"].focus(); };
                                    }}
                                    autocompleteType='GetUser'
                                    value={formData.reportingHead3 || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, reportingHead3: newInputValue })
                                        }
                                    }}

                                />
                                <DateBox
                                    inputrefs={inputrefs}
                                    label="Date of Joining"
                                    required={true}
                                    //divclassname='col-md-4'
                                    placeholder="DD-MMM-YYYY"
                                    id='txtDOJ'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtLocalAddress'].focus()
                                        };
                                    }}
                                    selected={formData.doj === '' ? '' : new Date(formData.doj)}
                                    onChange={(e) => handleDateChange(e, setFormData, formData, 'doj')}
                                />

                                <InputBox
                                    id="txtLocalAddress"
                                    placeholder="Enter Local Address"
                                    autoComplete="off"
                                    maxLength='250'
                                    label='Local Address'
                                    value={formData.lAddress}
                                    //divclassname="col-md-4"
                                    onChange={(e) => setFormData({ ...formData, lAddress: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPerAddress'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtPerAddress"
                                    placeholder="Enter Per. Address"
                                    autoComplete="off"
                                    maxLength='250'
                                    label='Per. Address'
                                    value={formData.pAddress}
                                    //divclassname="col-md-4"
                                    onChange={(e) => setFormData({ ...formData, pAddress: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtUserType'].focus()
                                        }
                                    }}
                                />
                                <SelectInputBox
                                    id="txtUserType"
                                    value={formData.userType}
                                    label='User Type'
                                    onChange={(e) => setFormData({ ...formData, userType: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPhone'].focus()
                                        }
                                    }}
                                //divclassname="col-md-4 "
                                >
                                    <option key="hi" value=''>--Please Select--</option>
                                    {GetUserType?.data?.dropDownData?.map((item, index) =>
                                        <option key={item.textPart + index} value={item.valuePart}>{item.textPart}</option>
                                    )}
                                </SelectInputBox>
                                <InputBox
                                    id="txtPhone"
                                    placeholder="Enter Phone No"
                                    autoComplete="off"
                                    maxLength='10'
                                    label='Phone No'
                                    value={formData.phone}
                                    // divclassname="col-md-4 "
                                    onChange={(e) => setFormData({ ...formData, phone: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEmailID'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    type="email"
                                    id="txtEmailID"
                                    label='Email ID'
                                    placeholder="Enter Email ID"
                                    maxLength='50'
                                    name='EmailId'
                                    value={formData.emailID}
                                    //divclassname="col-md-4 "
                                    onChange={(e) => setFormData({ ...formData, emailID: sanitizeInput(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtDiscountPercent'].focus()
                                        }
                                    }}
                                />
                                <InputBox
                                    id="txtDiscountPercent"
                                    label='Discount % threshold'
                                    placeholder="Enter Discount % threshold"
                                    maxLength='5'
                                    name='Discount % threshold'
                                    value={formData.discountPercent}
                                    //divclassname="col-md-4 "
                                    onChange={(e) => setFormData({ ...formData, discountPercent: convertTwoDecimalsOnValue(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                />
                                <Switch
                                    size='lg'
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.active}
                                    id='txtActive'
                                    divclassname="col-md-3 mt-2 inline-flex"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtSuperAdmin'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                />

                                <Switch
                                    size='lg'
                                    inputrefs={inputrefs}
                                    label='Super Admin'
                                    checked={formData.isSuperAdmin}
                                    id='txtSuperAdmin'
                                    //divclassname="col-md-4 mt-4"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtSOPrint'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isSuperAdmin: e.target.checked })}
                                />

                                <Switch
                                    size='lg'
                                    inputrefs={inputrefs}
                                    label='SO Print'
                                    checked={formData.soPrint}
                                    id='txtSOPrint'
                                    //divclassname="col-md-4"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, soPrint: e.target.checked })}
                                />
                            </div>
                        </div>
                    </div>

                </div>
                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/User/ShowUserMaster`, filterData, 'User Master')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>
            </div>


            <div className="">
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'UserMaster'}
                    handleFilter={() => {
                        getUserMasterData(1)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}

                />
            </div>
        </>
    )
}
export default UserMaster;